import { render, staticRenderFns } from "./LeftItem.vue?vue&type=template&id=36589a9b&scoped=true&"
import script from "./LeftItem.vue?vue&type=script&lang=js&"
export * from "./LeftItem.vue?vue&type=script&lang=js&"
import style0 from "./LeftItem.vue?vue&type=style&index=0&id=36589a9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36589a9b",
  null
  
)

export default component.exports